import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';

import { ROUTE_ANIMATIONS_ELEMENTS, LgvAPIService, LgvUserService } from '../../../core/core.module';

@Component({
    selector: 'lgv-mortgage-footer',
    templateUrl: './mortgage-footer.component.html',
    styleUrls: ['./mortgage-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MortgageFooterComponent implements OnInit {
    routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

    constructor(public LgvAPI: LgvAPIService, public LgvUserSvc: LgvUserService ) { }

    _CoBrandingCompanyName: string = '';
    CoBrandingCompanyName$ = new BehaviorSubject(this._CoBrandingCompanyName);

    //CompanyName = 'XXX';

    ngOnInit() {
        this.LgvUserSvc.IsCoBranding$.pipe(first(f => f !== null)).subscribe(isCB => {
            //console.log('IsCoBranding$:');
            //console.log(isCB);

            if (isCB) {
                this.LgvUserSvc.CoBrandedAgentDTO$.pipe(first(f => f !== null)).subscribe(x => {
                    //console.log('CoBrandedAgentDTO$:');
                    //console.log(x);
                    this.CoBrandingCompanyName$.next(x.company.name);
                });
            }
        });


    }
}
